import { type FC, memo, useState } from 'react';
import styles from './index.module.scss';
import logo from '@assets/images/header/parrot-logo.svg';
import logoText from '@assets/images/header/parrot-text.svg';
import pointIcon from '@assets/images/header/point-icon.svg';
import downIcon from '@assets/images/header/down.svg';
import { menus } from 'src/routers/menu';
import ConnectWallet from '@components/connect-wallet';
import { ExplorerSetting } from './explorer-setting';
import MenuList from './menu-list';
import Links from './links';
import Popover from '@ui/parrot/popover';

const Header: FC = () => {
  const [open, setOpen] = useState(false);

  const $menus = menus.map((menu) => {
    return <MenuList menu={menu} key={menu.key} />;
  });

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <Popover content={<Links />} trigger={'click'} open={open} onOpenChange={setOpen}>
            <div className={styles.logo_con}>
              <img src={logo} alt="Parrot" title="Parrot" className={styles.logo_img} />
              <img src={logoText} alt="Parrot" title="Parrot" className={styles.logo_text} />
              <img src={downIcon} className={`${styles.down} ${open ? styles.up : ''}`} />
            </div>
          </Popover>
        </div>
        <div className={styles.menus}>{$menus}</div>
        <div className={styles.right}>
          {/* <div className={styles.points}>
            <img src={pointIcon} data-icon />
            <span>Points</span>
          </div> */}
          <ConnectWallet />
          <ExplorerSetting />
        </div>
      </div>
    </>
  );
};

export default memo(Header);
